<template>
  <div>
    <a-modal v-model:visible="visible" :title="'医生详情'" @ok="handleOk" okText="保存" cancelText="返回" :afterClose="closeModal" width="28vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="style1">
          <div class="box">
            <label>每时段预约人数：</label>
            <a-input v-model:value="record.appSetting.defaultScheduleCount" />
          </div>
          <div class="box">
            <label>推荐指数：</label>
            <a-input-number :min="1" v-model:value="record.appSetting.recommendIndex" />
          </div>
          <div class="box">
            <label>是否出诊：</label>
            <a-radio-group v-model:value="record.appSetting.scheduleAvailable" @change="handleChange" size="large" style="margin-bottom:20px;">
              <a-radio-button :value="true">是</a-radio-button>
              <a-radio-button :value="false">否</a-radio-button>
            </a-radio-group>
          </div>

        </div>

      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {
  CheckCircleFilled
} from "@ant-design/icons-vue";
import { DoctorSetting } from "/src/api/appointment.js";
// import addPrescription from '/src/components/prescription/addPrescription.vue';
import { cloneDeep } from "lodash-es";

export default {
  components: {
    CheckCircleFilled
  },
  data() {
    return {
      id: "",
      visible: this.modelValue,
      showTable: 0,
      medicineFilter: "",
      title: "",
      inputs: {
        name: "",
        description: ""
      },
      prescription: "",
      data: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      selectedRow: {},
      editableData: {},
    };
  },
  emits: ['update:modelValue'],
  created() {
  },
  mounted() {
    console.log(this.record.appSetting?.scheduleAvailable);

  },
  activated() {
  },
  //获取父元素传值
  props: {
    record: {
      type: Object,
      default: {},
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
  },
  computed: {
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleChange() {
      if (this.record.appSetting.defaultScheduleCount <= 0 && this.record.appSetting.scheduleAvailable) {
        this.record.appSetting.defaultScheduleCount = 1
      }

    },
    closeModal() {
      this.$emit('update:modelValue', false);
      // this.record = {}
    },
    async handleOk() {
      // console.log(this.record);
      // return
      if (this.record.appSetting.defaultScheduleCount <= 0 && this.record.appSetting.scheduleAvailable) {
        this.$message.error("每时段预约人数必须大于0");
        return
      }
      let parmas = {}

      if (this.record.appSetting.id) {
        parmas = {
          id: this.record.appSetting.id,
          defaultScheduleCount: this.record.appSetting.defaultScheduleCount,
          scheduleAvailable: this.record.appSetting.scheduleAvailable,
          recommendIndex: this.record.appSetting.recommendIndex,
        }
      } else {
        parmas = {
          doctorId: this.record.id,
          defaultScheduleCount: this.record.appSetting.defaultScheduleCount,
          scheduleAvailable: this.record.appSetting.scheduleAvailable,
          clubId: this.record.clubId,
          recommendIndex: this.record.appSetting.recommendIndex,
        }
      }
      let res = await DoctorSetting(parmas)
      if (res.errCode == 0) {
        this.$message.success("完成", function () { });
        this.visible = false
        this.$emit('reSearch');
        // this.record = {}
      }

    },

  },
  watch: {
    record(val) {
      // this.detail()
    },
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.thead {
  text-align: center;
  font-weight: bold;
  letter-spacing: 0.5em;
}
.style1 {
  position: relative;
}
.style1 > .box {
  padding-left: 5%;
  display: flex;
}
.box label {
  width: 35%;
}

.box .ant-select,
.box .ant-input,
.box .ant-input-number,
.box .ant-input-textarea {
  width: 65%;
  margin-bottom: 20px;
}
.box .ant-radio-group {
  width: 35%;
}
.ant-radio-button-wrapper {
  text-align: center;
}
</style>
